import React from 'react';
import classNames from 'classnames';
import moment from 'moment';

interface Props {
	day: string;
	date: string;
	slotAvailable: number;
	isSelected: boolean;
	setSelectedDaySlot: (value: any) => void;
	availability: any;
	startTime: any;
}

export const DateSlotsCard = ({
	day,
	date,
	setSelectedDaySlot,
	slotAvailable,
	isSelected,
	availability,
	startTime,
}: Props) => {
	const isDark = true;
	return (
		<button
			className={classNames(
				'flex-shrink-0 items-center px-[16px] py-[8px] rounded-[8px] flex flex-col gap-[6px] cursor-pointer transition-all duration-200',
				isSelected
					? 'bg-[#7777E7] border border-[#5a85e4] text-white'
					: 'bg-[#F7F7FF] border border-[#D6E2FA] text-black',
			)}
			onClick={() => setSelectedDaySlot(availability)}
		>
			<p className="text-xs">{day}</p>
			<p className={classNames('font-inter', { ' text-[#FFF]': isSelected })}>{date}</p>
			<p className={classNames(isSelected && isDark ? 'text-xs text-[#57EBA1]' : 'text-xs text-[#05A660]')}>
				{slotAvailable} Slots
			</p>
		</button>
	);
};
